import { DateTime } from "luxon";

export const IS_DEV = process.env.NODE_ENV !== "production";
export const IS_PROD = process.env.NODE_ENV === "production";

export const AUTH_IFRAME_URL = "https://vk.com";
export const AUTH_PROMO_URL = "https://www.fbaugust.ru/strategii/investing/";
export const AUGUST_DATE_FOUNDATION = DateTime.fromObject({ year: 1997 }).setLocale("ru");

export const IS_DEV_ENV = process.env.REACT_APP_ENV !== "production";
